import { Group, Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"
import { useOutletContext } from "react-router-dom"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { InvoiceItemDto } from "~/gen/api"
import { InvoiceCreationModal } from "~/pages/Admin/Invoices/InvoiceCreationModal"
import { InvoicesTable } from "~/pages/Brand/Invoices/InvoicesTable"

type Props = {
  invoices: InvoiceItemDto[]
}
export const InvoicesAdmin = ({ invoices }: Props) => {
  const { t } = useTranslation("admin")

  const organization = useOutletContext<AdminResponses.Organization>()

  const [isModalOpen, setIsModalOpen] = useDisclosure(false)

  return (
    <Stack>
      <Group justify="right">
        <Button onClick={setIsModalOpen.toggle} icon={<IconPlus />}>
          {t("invoices.createButton")}
        </Button>
      </Group>
      <InvoicesTable orgName={organization.name} invoices={invoices} />
      <InvoiceCreationModal
        opened={isModalOpen}
        onClose={setIsModalOpen.close}
      />
    </Stack>
  )
}
